import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { initSentry } from "@/lib/sentry";
import { FeatureFlagProvider } from "@/lib/feature-flags/provider";
import { initDevMode } from "@/lib/dev-mode";

initSentry();
initDevMode(); // no-op unless VITE_DEV_AUTH_BYPASS is on -- see docs/DEV_MODE.md

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <FeatureFlagProvider>
      <App />
    </FeatureFlagProvider>
  </StrictMode>
);
